import React from 'react';
import { Toaster as Sonner } from 'sonner';

// Mirror the legacy react-toastify class names onto sonner's elements so
// existing cypress selectors (`.Toastify__toast`, `.Toastify__toast--info`,
// etc.) keep working without changing the specs.
const Toaster = (props) => (
	<Sonner
		theme="dark"
		position="top-right"
		closeButton
		offset={16}
		className="Toastify__toast-container"
		toastOptions={{
			classNames: {
				toast: 'Toastify__toast border border-border bg-card text-card-foreground shadow-lg',
				title: 'text-card-foreground',
				description: 'text-muted-foreground',
				success: 'Toastify__toast--success border border-green-base bg-card text-card-foreground',
				info: 'Toastify__toast--info border border-primary bg-card text-card-foreground',
				warning: 'Toastify__toast--warning border border-yellow-base bg-card text-card-foreground',
				error: 'Toastify__toast--error border border-destructive bg-card text-card-foreground',
				loading: 'border border-border bg-card text-card-foreground',
				actionButton: 'bg-primary text-primary-foreground',
				cancelButton: 'bg-secondary text-secondary-foreground',
				closeButton: 'border-border bg-card text-muted-foreground hover:bg-accent hover:text-accent-foreground'
			}
		}}
		{...props}
	/>
);

export { Toaster };
